import { createSlice } from "@reduxjs/toolkit";
import { receiveProducts as receiveProductsAction } from "../search/actions";
import { updateClientWidth } from "../layout";
import receiveProducts from "./reducer/receiveProducts";
import updateValidSlotSizes from "./reducer/updateValidSlotSizes";

const initialState = {
  validSlotSizes: []
};

const advertsSlice = createSlice({
  name: "adverts",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(receiveProductsAction, (state, action) =>
      receiveProducts(state, action)
    );
    builder.addCase(updateClientWidth, (state, action) =>
      updateValidSlotSizes(state, action)
    );
  }
});

export const reducer = advertsSlice.reducer;
export {
  getAppLevelTargeting,
  getAdSpecificTargeting,
  getPriorProductsFingerprint,
  getValidSlotSizes,
  getAdUnitPath,
  getPageLevelTargeting
} from "./selectors";
